module.exports = __webpack_public_path__ + "static/media/me.1befc9d4.png";